import { Box, Skeleton } from "@mui/material";

// Shared list/grid loading placeholder for the AA Projects surfaces (spec
// §5.10 P0: "every grid/list has a loading state — skeleton, no layout shift;
// never blank on navigation"). Rows match the eventual content height so the
// layout does not jump when data lands, unlike a centered CircularProgress.
interface ListSkeletonProps {
  rows?: number;
  height?: number;
  testId?: string;
}

export default function ListSkeleton({
  rows = 4,
  height = 32,
  testId,
}: ListSkeletonProps) {
  return (
    <Box data-testid={testId}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={height} sx={{ my: 0.5 }} />
      ))}
    </Box>
  );
}
